import { Box, Section, Text } from "@origin-digital/ods-core";
import { IconChevronLeftSmall, IconClose } from "@origin-digital/ods-icons";
import React from "react";
import styled from "styled-components";
import { ActionBarProps } from "./ActionBar";
import { NavTitle } from "./NavTitle";

export const IconButton = styled.button`
  appearance: none;
  align-items: center;
  background-color: transparent;
  border: 0;
  box-shadow: none;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  line-height: 24px;
  padding: 14px;
  user-select: none;
  vertical-align: middle;
  width: auto;
  outline: none;
  margin-left: -${({ theme }) => theme.space.medium}px;

  & .MuiSvgIcon-root {
    font-size: ${({ theme }) => theme.shape.iconSizes.xxsmall};
  },
`;

const CloseText = styled(Text)`
  padding-left: 4px;
`;

export interface ActionBarMobileProps extends ActionBarProps {
  title?: string;
  isDesktop?: boolean;
}

export function getMobileNavButton(
  mobileNavButton: ActionBarProps["mobileNavButton"],
  onClickMobileNavButton: ActionBarProps["onClickMobileNavButton"],
  isDesktop: boolean = false,
  desktopVariant?: ActionBarProps["desktopVariant"],
  showPropertySelector?: boolean
) {
  if (mobileNavButton === "none") {
    // Don't show placeholder when PropertySelector is displayed
    if (showPropertySelector) {
      return null;
    }
    // placeholder to help keep the title centered
    return (
      <Box
        display="flex"
        style={{ height: "44px", width: isDesktop ? "auto" : "44px" }}
        justifyContent="flex-end"
      />
    );
  } else if (mobileNavButton === "close") {
    return (
      <IconButton
        data-id={`button-close${isDesktop ? "-desktop" : ""}`}
        onClick={onClickMobileNavButton}
        aria-label="Close Flow"
      >
        <IconClose color="neutralDark" size="xxsmall" variant="solid" />
        {desktopVariant === "slim" ? (
          <>
            <Box marginLeft="xxsmall" />
            <CloseText tone="neutralDark" weight="medium">
              Close
            </CloseText>
          </>
        ) : null}
      </IconButton>
    );
  } else if (mobileNavButton === "back") {
    return (
      <IconButton
        data-id={`button-back${isDesktop ? "-desktop" : ""}`}
        onClick={onClickMobileNavButton}
        aria-label="Back"
      >
        <IconChevronLeftSmall
          color="neutralDark"
          variant="solid"
          size="xxsmall"
        />
        {desktopVariant === "slim" ? (
          <>
            <Box marginLeft="xxsmall" />
            <Text tone="neutralDark" weight="medium">
              Back
            </Text>
          </>
        ) : null}
      </IconButton>
    );
  }
  return null;
}

export const ActionBarMobile = ({
  mobileNavButton,
  headingComponent,
  onClickMobileNavButton,
  title,
  showPropertySelector,
  propertySelector,
  onClickHelpSupportButton,
  secondaryColor = false,
}: ActionBarMobileProps) => {
  return (
    <Section
      paddingY="none"
      data-id="mobile-container"
      backgroundColor="transparent"
    >
      <Box display="flex" justifyContent="space-between">
        <NavTitle
          mobileNavButton={mobileNavButton}
          headingComponent={headingComponent}
          onClickMobileNavButton={onClickMobileNavButton}
          title={title}
          showPropertySelector={showPropertySelector}
          propertySelector={propertySelector}
          onClickHelpSupportButton={onClickHelpSupportButton}
          secondaryColor={secondaryColor}
        />
      </Box>
    </Section>
  );
};
